// extracted by mini-css-extract-plugin
export default {"button":"TimerButton_button__n3eGi","timerActive":"TimerButton_timerActive__Mrjj5","container":"TimerButton_container__Junlj"};